// Pure helper split out of `../components/route-error-fallback.tsx` so it can
// be unit-tested from the root-level vitest (which resolves under the repo's
// root package.json and can't reach `react` in web/node_modules). Same shape
// as venue-home-decisions.ts + router-decisions.ts.

export function extractErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message) return error.message;
  if (typeof error === "string" && error) return error;
  return "Unexpected error";
}
